import React, { useEffect, useState } from 'react';
import { PlayArrowRounded } from "@mui/icons-material";
import { Box, Typography, Chip, Grid, Avatar, Paper, IconButton } from '@mui/material';
import { resolveVideoPreview } from '../../network/cloudflare_stream_service/CloudflareStream_api_callback';
import { extractVimeoId, getVimeoPlayLink } from '../../network/vimeo_network_service/Vimeo_api_callback';

const optionColors = [
    'primary', 'secondary', 'info', 'warning'
];

const getDifficultyColor = (difficulty) => {
    switch (difficulty?.toLowerCase()) {
        case 'easy': return 'success.main';
        case 'medium': return 'warning.main';
        case 'difficult':
        case 'hard': return 'error.main';
        default: return 'grey.500';
    }
};

const QuestionListItem2 = ({
    item = {},
    index = 0,
    onPlay,
    onClick,
    isActive
}) => {
    const {
        videoUrl,
        id,
        contentId,
        difficulty,
        form,
        gameType,
        status,
        questionText,
        options = [],
        entity = {},
    } = item;

    const image = item?.entities?.[0]?.displayImage; // using first entity's image as thumbnail
    const multimedia = item?.multimedia || { url: videoUrl, form: 'video', cloudFlareVideoId: item?.cloudFlareVideoId };
    const preview = resolveVideoPreview(multimedia);
    const vimeoId = extractVimeoId(videoUrl || multimedia?.url);
    const [videoSrc, setVideoSrc] = useState(null);

    // Fetch video only when this card becomes active
    useEffect(() => {
        const loadVideo = async () => {
            if (!isActive) {
                setVideoSrc(null);
                return;
            }
            if (preview.type === 'cloudflare') {
                setVideoSrc(preview.embedUrl);
                return;
            }
            try {
                const { progressiveLink, playLink } = await getVimeoPlayLink(vimeoId);
                setVideoSrc(progressiveLink || playLink);
            } catch (err) {
                console.error("❌ Error fetching Vimeo link:", err);
            }
        };
        loadVideo();
    }, [isActive, videoUrl, preview.type, preview.embedUrl, vimeoId]);

    return (
        <Paper 
        elevation={3}
        onClick={onClick}
        sx={{
            p: 2,
            mt: 1,
            mb: 1, 
            borderRadius: 2,
            height: 'auto',   //520
            minHeight: 480,
            width: 350,
            minWidth: 350,
            backgroundColor: "whitesmoke",
            alignSelf:'flex-start'
        }}>
            {/* Row 1: Video with index */}
            <Box sx={{ position: 'relative', width: '100%', mb: 1, borderRadius: 2, p: 0, backgroundColor: '#E9E9E9' }}>
                {/* Video View (replace with your video player as needed) */}
                <Box
                    sx={{
                        position: "relative",
                        width: "100%",
                        height: 160,
                        backgroundImage: !isActive
                            ? `url(${image || ""})`
                            : "none",
                        backgroundSize: "cover",
                        bgcolor: "rgba(0,0,0,0.6)",
                        backgroundPosition: "center",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: 2,
                    }}
                >
                    {/* Overlay gradient */}
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                            background: "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.1))",
                            borderRadius: 2,
                        }}
                    />

                    {/* Play button */}
                    {/* <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "white",
                        }}
                    >
                        <PlayCircleOutline sx={{ fontSize: 50, opacity: 0.9 }} />
                    </Box> */}

                    {!isActive ? (
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation(); // prevent triggering onClick selection
                                onPlay();
                            }}
                            sx={{
                                bgcolor: "rgba(0,0,0,0.6)",
                                color: "white",
                                "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
                                p: 3,
                            }}
                        >
                            <PlayArrowRounded fontSize="large" />
                        </IconButton>
                    ) : (
                        // <Vimeo
                        //     video={playableVimeoVideoUrl?.uri?.replace("/videos/", "")}
                        //     autoplay
                        //     responsive
                        //     controls = {true}
                        //     playsInline
                        //     style={{ width: "100%", height: "100%" }}
                        //     options={{
                        //         title: true,      // hides video title
                        //         byline: true,     // hides "by username"
                        //         portrait: false,   // hides profile image
                        //         autopause: true,   // stop other videos when this plays
                        //         transparent: false,// keep player background solid
                        //         dnt: false,         // do not track viewer
                        //         controls: false,    // show/hide playbar
                        //         keyboard: false,   // disable keyboard shortcuts
                        //         pip: false,        // disable Picture-in-Picture
                        //         autoplay: false,    // force autoplay (if allowed by browser)
                        //         loop: false,       // disable looping
                        //         muted: false       // start unmuted
                        //     }}
                        // />
                        videoSrc && (
                            preview.type === 'cloudflare' ? (
                                <iframe
                                    title={`cf-${id}`}
                                    src={videoSrc}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        border: 0,
                                        borderRadius: 2,
                                        backgroundColor: "black",
                                    }}
                                    allow="autoplay; fullscreen; picture-in-picture"
                                    frameBorder="0"
                                />
                            ) : (
                                <video
                                    src={videoSrc}
                                    controls
                                    autoPlay
                                    playsInline
                                    controlsList="nodownload"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: 2,
                                        backgroundColor: "black",
                                    }}
                                    onPause={() => console.log("paused")}
                                />
                            )
                        )
                    )}
                </Box>
                <Typography variant="caption" sx={{ position: 'absolute', top: 1, right: 1, bgcolor: 'rgba(0,0,0,0.7)', color: '#fff', px: 1, borderRadius: 1 }}>
                    {status}
                </Typography>
            </Box>

            {/* Row 2 & 3 & 4: in column layout */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 0.5, textAlign: 'start' }}>
                {/* Row 2 */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2" sx={{ flex: 1, textAlign: 'start', fontWeight: 700, fontSize: 12 }}>{id}</Typography>
                    <Typography variant="body2" sx={{ flex: 1, textAlign: 'end', fontSize: 11 }}>Content ID: {contentId}</Typography>
                </Box>
                {/* Row 3 */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2" sx={{ flex: 1, textAlign: 'start', fontSize: 12 }}>{gameType?.toUpperCase()}</Typography>
                    <Typography variant="body2" sx={{ flex: 1, textAlign: 'end', fontSize: 11 }}>Vimeo ID: {vimeoId}</Typography>
                </Box>
                {/* Row 4: Form & Difficulty */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, mb: 0.5 }}>
                    <Typography variant="body2" sx={{ flex: 1, color: getDifficultyColor(difficulty), fontWeight: 800, textAlign: 'start', fontSize: 12 }}>{difficulty}</Typography>
                    <Typography variant="body2" sx={{ flex: 1, textAlign: 'end', fontSize: 11 }}>Form: {form}</Typography>
                </Box>
            </Box>

            <div style={{ height: 1, backgroundColor: '#eee', marginBottom: 8 }} /> 

            {/* Row 5: Question Text */}
            <Box sx={{ mb: 0.5 }}>
                <Typography
                    variant="subtitle1"
                    sx={{
                        flex: 1,
                        height: 40,
                        mt: 1,
                        textAlign: 'start',
                        fontWeight: 800,
                        fontSize: 12,
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'normal',
                    }}
                >
                    {questionText}
                </Typography>
            </Box>

            {/* Row 6: Options as chips */}
            <Box sx={{ display: 'flex', gap: 1, mt:1, mb: 1, flexWrap: 'wrap', alignItems: 'center', alignContent: 'center', justifyContent: 'center' }}>
                {options.map((opt, i) => (
                    <Chip
                        key={i}
                        label={
                            <span>
                                <b>{opt.label}:</b> {opt.text}
                            </span>
                        }
                        color={opt.isCorrect ? 'success' : 'default'}
                        sx={{ bgcolor: opt.isCorrect ? 'success.main' : 'grey.200', color: opt.isCorrect ? '#fff' : 'inherit', fontWeight: opt.isCorrect ? 700 : 400, minWidth: 120 }}
                    />
                ))}
            </Box>

            <div style={{ height: 1, backgroundColor: '#eee', marginBottom: 8 }} /> 

            {/* Row 7: Entity details and image */}
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={8} sx={{flex:1.5, display: 'flex', flexDirection: 'column', gap: 0.5, justifyContent: 'flex-start', height:'100%' }}>
                    <Box sx={{flex:1, flexDirection:'column', display:'flex', gap:0.2, alignItems:'flex-start'}}>
                        <Typography variant="body2">{entity.id}</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700, fontSize: 12 }}>{entity.name}</Typography>
                        <Typography variant="body2">{entity.type}</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700, fontSize: 12 }}>Weightage: {entity.weightage}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={4} sx={{ flex:0.5, display: 'flex', height:'100%', justifyContent: 'flex-end' }}>
                    {entity.imageUrl && (
                        <Avatar src={entity.imageUrl} alt={entity.name} sx={{ flex:1, width: 75, height: "100%", borderRadius:2, borderColor:'#707070', borderWidth:1, borderStyle:'solid' }} />
                    )}
                </Grid>
            </Grid>
        </Paper>
    );
};

export default QuestionListItem2;
